import { render, staticRenderFns } from "./myform.vue?vue&type=template&id=712c2d00&scoped=true&"
import script from "./myform.vue?vue&type=script&lang=js&"
export * from "./myform.vue?vue&type=script&lang=js&"
import style0 from "./myform.vue?vue&type=style&index=0&id=712c2d00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712c2d00",
  null
  
)

export default component.exports